export enum SellerPortalBlade {
  PROBLEM_BLADE = "PROBLEM_BLADE",
}
